
import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const updateMbit = createAsyncThunk(
  "updateMbit",
  async (data) => {

    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
        
    const response = await axiosHttp.post(
      `/gis/mbit/update`,
      {
        manager:data.manager,
        code:data.code,
        sbits:data.sbits
      },
      config,
    );

    return response.data;
  }
);

const mbitUpdateSlice = createSlice({
  name: "mbitUpdate",
  initialState: {
    isLoading: false,
    status: null,
    message: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateMbit.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateMbit.fulfilled, (state, action) => {
      state.isLoading = false;
      state.status = action.payload.status;
      state.message = action.payload.message;
    });
    builder.addCase(updateMbit.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default mbitUpdateSlice.reducer;